module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("THREE POWERFUL WAYS TO OVERCOME CHALLENGES IN WORK AND LIFE")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_vm._v("Be the Hero")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("NOAH BLUMENTHAL")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("Foreword by Marshall Goldsmith")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cfad99f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch0003_title.vue
// module id = 66
// module chunks = 0